import { Component } from '@angular/core';

import type { OnInit } from '@angular/core';

@Component({
    selector: 'app-trabajadores',
    templateUrl: './trabajadores.component.html',
    styleUrls: ['./trabajadores.component.scss']
})
export class TrabajadoresComponent implements OnInit {

    constructor() { }

    ngOnInit() {

    }

}
